<ng-container *ngIf="appInstall.state$ | async as state">
  <div *ngIf="state.shouldShowPrimaryCta" class="app-install-cta" [ngClass]="{'app-install-cta--compact': compact}">
    <div class="app-install-cta__actions">
      <button
        pButton
        pRipple
        type="button"
        class="p-button-rounded app-install-cta__trigger"
        [icon]="'pi pi-mobile'"
        iconPos="left"
        [label]="'shared.install.primary_button' | translate"
        [rounded]="true"
        (click)="appInstall.handlePrimaryAction()"
      ></button>
    </div>
  </div>
</ng-container>
